// @flow

import {
    CONTENT_TYPE_JSON,
    TRANSPORT_GET_PARAMS,
    TRANSPORT_REQUEST_BODY,
    TRANSPORT_REQUEST_FILE,
    TRANSPORT_REQUEST_PARAMS
} from './constants';
import {prepareBodyData} from './transport/request-body';
import {prepareBodyParams} from './transport/request-params';
import {prepareFileData} from './transport/request-file';
import {prepareQueryParams} from './transport/get-params';
import {getUrl} from './utils/get-url';

import type {CallInfo} from './typedef';


type Output = {
    url: string,
    headers: { [key: string]: string },
    body?: string | FormData,
};

export const prepareRequestData = (
    callInfo: CallInfo<*>,
    apiRoot: string
): Output => {
    const {
        [TRANSPORT_REQUEST_BODY]: bodyData,
        [TRANSPORT_REQUEST_PARAMS]: bodyParams,
        [TRANSPORT_REQUEST_FILE]: fileData,
        [TRANSPORT_GET_PARAMS]: queryParams
    } = callInfo;

    let requestData = {
        headers: {
            'Accept': CONTENT_TYPE_JSON,
            'X-Requested-With': 'XMLHttpRequest',
            ...callInfo.headers
        },
        url: getUrl(callInfo, apiRoot)
    };

    if (bodyData) {
        requestData = {
            ...requestData,
            ...prepareBodyData({
                headers: requestData.headers,
                params: bodyData
            })
        };
    }

    if (bodyParams) {
        requestData = {
            ...requestData,
            ...prepareBodyParams({
                headers: requestData.headers,
                params: bodyParams
            })
        };
    }

    if (fileData) {
        requestData = {
            ...requestData,
            ...prepareFileData({
                params: fileData
            })
        };
    }

    if (queryParams) {
        requestData = {
            ...requestData,
            ...prepareQueryParams({
                url: requestData.url,
                params: queryParams
            })
        };
    }

    return requestData;
};

            // @pb/generate-flow-typed Webpack Loader:
            // Duplicates all internal dependencies imports
            // to be sure all deps are parsed by this loader
            // cause Babel loader removes `import type ...`
            // and e.g. 'typedef.js' files are not included in dist
            
require("./typedef");
